export const LANG_EN_NAME = 'en'

export const LANG_EN_TRANS = {
  INVALID_OBJECT_ID: 'Invalid document ID',
  MISSING_OBJECT_ID: 'Document ID missing',
  EMPTY_DOCUMENT: 'Empty document',
  DOCUMENT_VALIDATION_ERROR: 'Invalid document',
  MISSING_UNIQUE_KEY: 'Missing unique key',
  MISSING_AUTH_DATA: 'Authentication missing',
  CREDENTIALS_NOT_VALID: 'Invalid credentials',
  MISSING_MANDATORY_PRAMETER: 'Missing mandatory data',
  TOKEN_NOT_VALID: 'Invalid authentication',
  DOCUMENT_NOT_FOUND: 'Document not found',
  INCOMPATIBLE_CHANGE_STATUS: 'Invalid action',
  DUPLICATED_DOCUMENT: 'Duplicated document',
  REMOTE_UNREACHABLE: 'Service temporarily unavailable',
  REMOTE_API_ERROR: 'External API error',
  GENERIC_ERROR: 'Generic error',
  MALFORMED_BODY: 'Invalid request',
  ERROR_CALLING_EXTERNAL_API: 'Carrier API error',
  'Something went wrong. Try again later.':
    'Something went wrong. Try again later.',
  'Can add orders from closed bordereau':
    'Cannot add orders to a bordereau in SHIPPED status',
  'Can remove orders from closed bordereau':
    'Cannot remove orders from a bordereau in SHIPPED status',
  'Cannot ship more quantity than ordererd':
    'You cannot ship more quantity than ordered',
  'Cant add specified product or same location is already set':
    'Cannot add product or location already present',
  'Cant change status': 'Cannot change status',
  'Cant delete closed bordereau': 'Cannot delete bordereau in SHIPPED status',
  'Cant find generic carrier for this warehouse ':
    'Generic carrier not set for this warehouse',
  'Cant find shipment for the specified order':
    'No shipment found for this order',
  'Cant find specifed product': 'Product not found',
  'Cant find specified location': 'Location not found',
  'Cant find specified order': 'Order not found',
  'Cant find specified payment type': 'Cannot find the specified payment',
  'Cant find specified product': 'Product not found',
  'Cant find valid user role': 'Invalid user role',
  'Cant find valid user session': 'Invalid user session',
  'Document is not unique': 'The document is not unique',
  'Error during token decoding': 'Error during token decoding',
  'ID list is not an array': 'ID list is not an array',
  'Invalid attribute ID': 'Invalid attribute ID',
  'Invalid ID': 'Invalid ID',
  'Invalid location label': 'Invalid location label',
  'Invalid mission ID': 'Invalid mission ID',
  'Invalid mission status update': 'Invalid mission status update',
  'Invalid options': 'Invalid option',
  'Invalid order ID': 'Invalid order ID',
  'Invalid picking list ID': 'Picking list ID not found',
  'Invalid product ID': 'Invalid product ID',
  'Invalid reason ID': 'Invalid reason ID',
  'Invalid request body': 'Invalid request body',
  'Invalid resource ID': 'Invalid resource ID',
  'Invalid tag ID': 'Invalid tag ID',
  'Invalid value': 'Invalid value',
  'Invalid value entry': 'Invalid value',
  'KITs cant have location': 'KITs cannot have locations',
  'Login failed': 'Login failed',
  'Login failed: provide a username and password':
    'Login failed: provide a username and password',
  'Malformed mission': 'Malformed mission',
  'Malformed picking list data': 'Malformed picking list data',
  'Malformed picking list orders data': 'Malformed picking list orders data',
  'Missing auth token': 'Authorization token missing',
  'Missing brands id': 'Brand ID not found',
  'Missing categories id': 'Category ID missing',
  'Missing mandatory param': 'Missing mandatory parameter',
  'Missing mandatory parameters': 'Missing mandatory parameter',
  'Missing manufacturers id': 'Manufacturer ID missing',
  'Missing product ID': 'Product ID missing',
  'Missing query parameters': 'Query parameter missing',
  'Missing tote code': 'Tote code missing',
  'Missing user': 'User missing',
  'Missing value': 'Value missing',
  'Missing value label': 'Value label missing',
  'Mission product not found': 'Product not found for the mission',
  'More than one product found': 'Multiple products found',
  'Movements must be under transaction':
    'Movements must be contained in a transaction',
  'No active session found': 'No active session',
  'No available actions': 'No available actions.',
  'No product found': 'Product not found',
  'Order is not confirmed': 'The order is not in CONFIRMED status',
  'Order not found': 'Order not found',
  'Packing list is not in processing status':
    'The packing list is not IN PROCESSING',
  'Picking list not in processing status':
    'The picking list is not IN PROCESSING',
  'Pickinglist orders property must be an array':
    'The orders property in picking lists must be an array',
  'Product not found': 'Product not found',
  'Product to move does not exists': 'Product to transfer does not exist',
  'Provide +|- to use with $inc operator': 'Use +|-|= to use the $inc operator',
  'Provide +|-|= to use with $inc operator':
    'Use +|-|= to use the $inc operator',
  'Provide a valid username': 'Enter a valid username',
  'Qty to move is negative': 'Quantity to transfer is negative',
  'Qty to move is not an integer':
    'The quantity to transfer is not a positive integer',
  'Quantity must be a positive integer':
    'The quantity must be a positive integer',
  'Quantity must me an integer': 'Quantity must be a positive integer',
  'Quantity must me positive': 'Quantity must be a positive number',
  'Quantity parameter is mandatory': 'The quantity is mandatory',
  'Reason not compatible with movement': 'Reason not compatible with movement',
  'Reason not found': 'Movement reason not found',
  'Select options not an array': '',
  'Some nodes are not reachable from the starting point':
    'Some nodes are not reachable from the starting point',
  'Source and target location are the same':
    'Same source and destination location',
  'Source location does not exists': 'The source location does not exist',
  'Source location not found': 'Source location not found',
  'Starting location is mandatory for building pickpath ':
    'Starting location is mandatory to generate the picking path',
  'StartVertex is missing from graph': 'StartVertex missing',
  'Target attribute not found': '',
  'Target location does not exists': 'The target location does not exist',
  'Target location not found': 'Target location not found',
  'Target order not found': '',
  'Target packing list not found': '',
  'Picking list not found': 'Picking list not found',
  'Target product location has not picked items': '',
  'Target product not found': '',
  'Target tag not found': '',
  'Target warehouse not found': 'Target warehouse not found',
  'The attribute value is an empty string': 'Enter a valid value',
  'The attribute value is not a boolean': 'The value is not a boolean',
  'The attribute value is not a number': 'The entered value must be a number',
  'The attribute value is not a string': 'The value is not a string',
  'The attribute value is not an integer':
    'The entered value must be an integer',
  'The attribute value is too long': 'Attribute value too long',
  'The attribute value is too short': 'Attribute value too short',
  'The attribute value must be a finite number': 'The value must be a number',
  'The old password provided is wrong': 'The old password entered is not valid',
  'The parent location must be root': 'The parent location must be root',
  'The picked qty must be an integer': 'The quantity must be an integer',
  'The picked qty must be positive or zero':
    'The quantity must be a positive integer',
  'The picking list is not in PENDING status':
    'The picking list is not in PENDING status',
  'The source location does not contains this product':
    'Product not present in the source location',
  'The source location does not have enough qty to move':
    'Quantity to transfer greater than stock',
  'The source location is reserved':
    'There are products reserved for a picking list',
  'The value have to be an object': 'The value must be an object',
  'There are attribute values': 'There are values for this attribute',
  'There are inventory items that are assigned to this warehouse':
    'There are products assigned to this warehouse',
  'There are locations with connected products':
    'The product is present in some locations',
  'There are missing picking locations Check warehouse structure':
    'Missing picking locations. Check warehouse structure',
  'There are orders that contains this product':
    'The product is present in some orders',
  'There are orders with this payment type':
    'There are orders with the specified payment method',
  'There are prodcuts that uses this brand':
    'Products associated with this brand',
  'There are prodcuts that uses this manufacturer':
    'Products associated with this manufacturer',
  'There are users items that are assigned to this warehouse':
    'There are users assigned to this warehouse',
  'There is already a brand with that name': 'Brand already exists',
  'There is already a manufacturer with that name':
    'Manufacturer already exists',
  'There is already an active session': 'User session already active',
  'There is already an attribute with that code':
    'An attribute with this code already exists',
  'There is more than one shipment for this order':
    'There is more than one shipment for this order',
  'There is no sufficient stock left': 'There is insufficient stock',
  'There is not a currently active packing list':
    'There are no active packing lists',
  'This action is not available': 'Action not available',
  'This order is inside a picking list':
    'The order is included in a packing list',
  'This packing list already exists': 'Packing list already exists',
  'This tenant doesnt have any ftp set':
    'This tenant does not have FTP profiles associated',
  'This tenant hasnt any carriers': 'The tenant has no carriers set',
  'This tote is used by another picking list':
    'Tote used for another picking list',
  'This value is already assigned': 'Value already assigned',
  'Token not valid.': 'Token not valid',
  'Too much qty packed': 'Packed quantity greater than requested',
  'Tote used by another order': 'Tote used for another order',
  'Unable to a valid action': '',
  'Unable to delete this category': 'Cannot delete category',
  'Unable to delete this tag': 'Cannot delete the tag',
  'Unable to fetch product data': 'Cannot retrieve product information',
  'Unable to fetch product info': 'Cannot get product information',
  'Unable to find a valid mission for the current order':
    'Cannot find valid missions for the current order',
  'Unable to find a valid picking list': 'Cannot find a valid picking list',
  'Unable to find a valid picking list to update':
    'Cannot find a picking list to update',
  'Unable to find Amazon and eBay channels for the current tenant':
    'Cannot find Amazon and eBay channel for this tenant',
  'Unable to find the current mission': 'Cannot find current mission',
  'Unable to find the current order': 'Cannot find current order',
  'Unable to find the Ecommerce channel for the current tenant':
    'Cannot find Ecommerce channel for this tenant',
  'Unable to find the packed order': 'Cannot find the packed order',
  'Unable to find the packing list to update':
    'Cannot find packing list to update',
  'Unable to find the picking list': 'Picking list not found',
  'Unable to find the product': 'Product not found',
  'Unable to find the target tote': 'Cannot find target tote',
  'Unable to find the tote inside product locations':
    'Tote not found in product locations',
  'Unable to load tote information': 'Cannot retrieve tote information',
  'Unexpected quantity to pack': 'Wrong quantity to pack',
  'Unexpected tenant': 'Unexpected tenant',
  'Unknown action': 'Unknown action',
  'User not found': 'User not found',
  'User permissions are too low to access this resource':
    'Insufficient user permissions to access this resource',
  'Wrong password provided': 'Wrong password',
  'Wrong product': 'Wrong product',
  'Wrong tote': 'Wrong tote',
  'Xlsx file header doesnt match the template file':
    'The file does not match the import template',
  'You are not authorized to access this resource':
    'Unauthorized access to resource',
  'You can only test when the picking list is in PENDING status':
    'Fulfillment simulation is only active in PENDING status',
  'You cannot change the attribute code': 'Cannot change the attribute code',
  'You cannot change the attribute kind': 'Cannot change the attribute type',
  'You cannot make an existing attribute unique':
    'Cannot set an existing attribute as unique',
  'You cannot skip the last mission': 'You cannot skip the last mission',
  'You cannot skip the last order': 'You cannot skip the last order',
  'You have to close the current packing list':
    'You must complete the packing of the current packing list before starting another',
  'You have to specify a custom reason': 'Specify movement reason',
  'Not Found': 'Item not found',
  'There are orders that contains this product.':
    'There are orders that contain this product',
  'Missing pickinglocation from the warehouse.':
    'Missing picking locations for this warehouse',
  'Missing required attribute': 'Missing mandatory configurations',
  'rcpt_prov: deve essere lungo al massimo 2 caratteri':
    'Invalid shipping address province',
  'dmo-availability': 'DMO export AVAILABILITY',
  'dmo-bolced': 'DMO import BOLCED',
  'dmo-carced': 'DMO export CARCED',
  'dmo-invced': 'DMO export INVCED',
  'dmo-magart': 'DMO import MAGART',
  'dmo-mapping': 'DMO import MAPPINGSKU-CART',
  'dmo-ordcli': 'DMO Export ORDCLI',
  'dmo-orders': 'DMO import Ecommerce ORDERS',
  'dmo-tracking': 'DMO export TRACKING',
  'dmo-status': 'DMO export ORDER STATUS',
  'trilab-dropship': 'Dropshipping Orders',
  'trilab-magento-shipments': 'Magento shipments',
  'trilab-store360-orders': 'Store360 Orders',
  'trilab-magento-orders': 'Magento Orders',
  'trilab-store360-shipments': 'Store360 shipments',
  'trilab-magento-availability': 'Ecommerce availability',
  'trilab-excel-availability': 'Excel Catalog',
  'amica-category': 'Export CATEGORY',
  'amica-eavs': 'Export EAVS',
  'amica-ite': 'Export ITE',
  'amica-prices': 'Export PRICES',
  'amica-stock': 'Export STOCK',
  'bene-exp-legacy': 'Export products',
  'bene-imp-legacy': 'Import orders',
  'Unable to pack this product': 'Cannot pack this product',
  ORDERS_FILE: 'Orders file',
  ROWS_FILE: 'Rows file',
  FTP_HOST: 'Host',
  FTP_PORT: 'Port',
  FTP_USERNAME: 'Username',
  FTP_PASSWORD: 'Password',
  FTP_ACTION: 'FTP Action',
  SOURCE_FILE: 'File name:',
  SOURCE_DIRECTORY: 'Source folder',
  SOURCE_PATTERN: 'Source pattern',
  TARGET_FILE: 'Target file name',
  TARGET_DIRECTORY: 'Target folder',
  TARGET_PATTERN: 'Target pattern',
  RECEIVER_MAIL: 'Email',
  'Unable to close the order if there is at least one unopened goods arrival':
    'Cannot close the supplier order if there are goods arrivals still in processing',
  'Found a product location not castable':
    'Product committed in picking list or awaiting packing',
  "Can't find location on the product.": 'Location not found for this product',
  'Product is not managed by batches.': 'The product is not managed by batches',
  'This location has reservedQty > 0.':
    'Location with quantities reserved for picking list',
  'New signature is already present in the batches.':
    'Batch already present in the selected location',
  'Invalid newQty: must be minor than old batch onHandQty.':
    'Invalid quantity: must be less than stock',
  'Invalid newQty: must be > 0.': 'Invalid quantity: must be greater than 0',
  'Provide two different batches.':
    'It is necessary to specify a batch different from the one already present',
  'Unable to reserve this batch':
    'It was not possible to reserve the requested quantity',
  'Tote already used by another picking list':
    'Tote already used by another picking list',
  'Unable to retrieve the required entity': 'Item not found',
  'ERRORE CORRIERE PRODUZIONE ETICHETTA':
    'Check order shipping address (max length 35 characters, invalid address/province, special characters, etc.)',
  WAREHOUSE_ID: 'Warehouse',
  FULL_CATALOG: 'Full catalog',
  Warehouse: 'Warehouse',
  INVALID_CREDENTIALS: 'Invalid credentials',
  'Invalid credentials': 'Invalid credentials',
  NOT_AUTHORIZED: 'Not authorized',
  "You haven't the authorization to perform this action":
    "You haven't the authorization to perform this action",
  '-No': 'No',
  'Goods return search hint':
    'Order ref, name|address|customer email, name|product sku',
  'Supplier order search hint': 'Order ref., name|product sku',
  'Suppliers search hint': 'Business name, address, email, code',
  'Customer search hint': 'Name, business name, addess, email, code',
  RECEIVED: 'Received',
  CLOSED: 'Closed',
  CANCELED: 'Canceled',
  PROCESSING: 'Processing',
  DRAFTED: 'Drafted',
  CONFIRMED: 'Confirmed',
  ASSIGNED: 'Assigned',
  'Invioces search hint': 'Invoice ref., name|inv. email, name|product sku',
  'Order search hint': 'Order ref., name|email, name|product sku',
  SHIPPED: 'Shipped',
  DELIVERED: 'Delivered',
  DROPSHIPPED: 'Dropshipped',
  HANDED: 'Handed',
  PACKED: 'Packed',
  'Unusable order description':
    'Products located inside LU. These products will not be taken into account for the picking process',
  'Received plural': 'Received',
  'Canceled plural': 'Canceled',
  'Processed product': 'Processed',
  'Product search hint': 'Product name, SKU, barcode, notes',
  'Warning order row description': "The 'Order alert' flag is activated",
  'Splitted order row description': 'The order was splitted',
  'Returned order row description':
    'The order was included in a goods return (only the border is coloured)',
  'Duplicated order row description': 'The orded was duplicated',
  'Order Packed': 'Packed',
  'Coverage available': 'Available',
  'Coverage unavailable': 'Unavailable',
  'Assigned m': 'Assigned',
  'Packing action': 'Packing',
  'Movement search hint': 'Product name | SKU',
  'Confirmed plural': 'Confirmed',
  'Stock stock': 'Stock',
  Selected_P: 'Selected',
}
